<template>
<div id="hres" class="hres">

	<div class="hres__profiles">
		<div class="profiles__header">
			<v-text-field
				class="header__input"
				v-model="filterObj.name"
				hide-details="true"
				label="name"
				solo
				prepend-inner-icon="mdi-account-circle"
				clearable
			></v-text-field>

			<v-text-field
				class="header__input"
				v-model="filterObj.position"
				hide-details="true"
				label="position"
				solo
				prepend-inner-icon="mdi-clipboard-account"
				clearable
			></v-text-field>

			<div class="header__pagination">
				<v-select
					class="row__family-status"
					:items="[20, 40, 60]"
					v-model="pagination.limit"
					label="family status"
					@change="readProfiles()"
				></v-select>

				<v-btn 
					depressed 
					large
					@click="prevPage()"
					class="header__btn blue create"
				>
					Create
				</v-btn>

				<v-btn 
					depressed 
					large
					@click="nextPage()"
					class="header__btn blue create"
				>
					Create
				</v-btn>
			</div>

			<v-btn 
				depressed 
				large
				:to="{name: 'hrprofile', params:{id:'create'}}"
				class="header__btn blue create"
			>
				Create
			</v-btn>
		</div>
		<router-link 
			class="profiles__profile"
			:to="{name: 'hrprofile', params: { id: profile.profile_id }}" 
			v-for="profile in filterProfiles" 
			:key="profile._id">

			<div class="profile__picture">
				<img 
					:src="getPicUrl(profile.picture)" 
					v-bind:alt="profile['first name']"/>
			</div>
			<div class="profile__info">
				<div class="info__name">
					{{profile['first name']+' '+profile['last name']}}
				</div>

				<div class="info__brief">

					<div 
						v-if="profile['position']"
						class="brief__position"
					>
						<div class="param__label iomico-style-lable">{{profile['position']}}</div>
						<div class="param__value"></div>
					</div>
				</div>
			</div>
		</router-link>
	</div>

</div>
</template>

<script>

// @ is an alias to /src

export default {
	name: 'hres',

	components: {
	}

	,computed:{

		filterProfiles: function(){
			if (!this.profiles) return [];
			let filterObj = this.filterObj;

			return this.profiles.filter(function(profile){
				if (!filterObj.name && !filterObj.position) return true;

				let name = filterObj.name 
							? (profile['first name'] + '|' + profile['last name']).toLowerCase().includes(filterObj.name)
							: null;

				let position = filterObj.position
								? profile['position'].toLowerCase().includes(filterObj.position)
								: null;

				if(name == null) return position;
				if(position == null) return name;
				return name && position;
			});
		}
	}

	,data: function(){
		return {
			profiles: null
			,loading: false
			,errored: false
			,filterObj: {
				name: ''
				,position: ''
			}
			,pagination: {
				limit: 100
				,skip: 0
			}
			,total: null
		};
	},

	methods:{
		getPicUrl: function(picFileName){
			return 'http://iomico.co/images/' 
					+ (picFileName || 'avatar__600x600.jpg');
		}

		,prevPage: function(){
			if(this.pagination.skip > 0)
			this.pagination.skip -= this.pagination.limit;
		}

		,nextPage: function(){
			this.pagination.skip += this.pagination.limit;
		}

		,readProfiles: function(){
			var url = 'http://iomico.co/api/profiles/'
			var params = {
				limit : this.pagination.limit
				,skip : this.pagination.skip
			}

			this.axios
				.get(url, {params: params})
				.then(response => {
					this.profiles = response.data;
				})
				.catch(error => {
					this.errored = true;
				})
				.finally(() => {
					this.loading = false;
				})
		}
	}

	,created(){

		//TODO: get limit & skip from URL query

	}

	,mounted(){
		this.readProfiles();
		console.log('MY_VAR', process.env.VUE_APP_MY_VAR);
		console.log('BASE_URL', process.env.BASE_URL);
	}

}
</script>
